import React, { ReactNode } from "react";
import "./emptystate.scss";

const EmptyState = (props) => {
  let { label = "No Students in Class", subLabel = "", image = "image.svg", actionButton } = props;

  return (
    <div
      role="alert"
      className="mpng-empty-state"
      style={{ marginTop: "29px" }}
      data-testid={props.testid || "mpng-empty-state"}
    >
      <div className="d-flex justify-content-center">{image ? image : null}</div>
      <div className="d-flex justify-content-center">
        <span className="label">{label}</span>
      </div>
      <div className="d-flex justify-content-center">
        <span className="sublabel">{subLabel}</span>
      </div>
      <div className="d-flex justify-content-center">{actionButton}</div>
    </div>
  );
};

export default EmptyState;
